import React from 'react';
import { ReactComponent as NotFound } from '../../../../assets/images/svg/404-img.svg';
import OiButton from '../OiButton/OiButton';

class SafeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ error: error, errorInfo: errorInfo });
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.errorInfo) {
            return (
                <div className="not-found__container">
                    <div className="not-found">
                        <h2 className="not-found__header">It seems an error occured!</h2>
                        <NotFound className="not-found__img" />
                        <h3 className="not-found__title u-half-gradient-bg">Spaceship Not Found</h3>
                        <p className="not-found__text">
                            {!navigator.onLine
                                ? 'Check your network and click on the blue button'
                                : 'kindly go back to previous page or click on the blue button to reload page'}
                        </p>
                        <div>
                            <OiButton
                                onClick={() => this.handleReload()}
                                styles="oi-btn oi-btn--primary oi-btn--radius5 | u-font14sb u-pad_1-2">
                                Reload
                            </OiButton>
                        </div>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default SafeComponent;
